import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const skillSetApiKeyStore = {
  createSkillSet: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_SKILL_SETS`],
    route: `/Skillset`,
    action: 'POST',
  }),
  updateSkillSet: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_SKILL_SETS`],
    route: `/Skillset`,
    action: 'PUT',
  }),
  deleteSkillSet: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_SKILL_SET`, id],
    route: `/Skillset/${id}`,
    action: 'DELETE',
  }),
  getSkillSets: (): QueryKeyConfig => ({
    queryKey: [`GET_SKILL_SETS`],
    route: `/Skillset`,
  }),
  getAssociatedServiceGroups: (): QueryKeyConfig => ({
    queryKey: [`GET_ASSOCIATED_SERVICE_GROUPS`],
    route: `/Skillset/AssociatedServiceGroups`,
  }),
};
